import BaseApi from './base/BaseApi';

export default class extends BaseApi {
  static entityName = 'crm_lead_reminders';
}
